import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getrapporttwin } from "../Redux/Actions/RapportTwinAction";
import CardRapportTwin from "./CardRapportTwin";
import './ListRapportsTwin.css';
import { Table, Button } from 'react-bootstrap';
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import html2canvas from "html2canvas";
import { PieChart } from '@mui/x-charts/PieChart';
import axios from 'axios';

function ListeRapportsTwin() {
  const dispatch = useDispatch();
  const chartRef = useRef(null);

  const ORIGINAL_TWIN_PARKS = [
    "Twin Park - Tunisia Mall",
    "Twin Park- Manar City",
    "Twin park - Jardins d'eL Menzah",
    "Jump Zone Mall of Djerba"
  ];

  const [locations, setLocations] = useState([]);

  useEffect(() => {
    dispatch(getrapporttwin());
    axios.get('/api/Locations/getAllLocations')
      .then(res => {
        const data = Array.isArray(res.data) ? res.data : [];
        const filtered = data.filter(l => ORIGINAL_TWIN_PARKS.includes(l.name));
        setLocations(filtered.length > 0 ? filtered : ORIGINAL_TWIN_PARKS.map(n => ({ _id: n, name: n })));
      })
      .catch(err => console.error("Erreur chargement emplacements :", err));
  }, [dispatch]);

  const rapports = useSelector((state) => state.RapportTwinReducer.RapportsTwin); 

  const calcul = (data) => {
    const totalAmount = data.reduce((acc, cur) => acc + (cur.TotalAmount || 0), 0);
    const totalTpe = data.reduce((acc, cur) => acc + (cur.TotalTpe || 0), 0);
    const totalDailyExpenses = data.reduce((acc, cur) => acc + (cur.DailyExpenses || 0), 0);
    const resultatnet = totalAmount - totalDailyExpenses;

    const playZoneStandard = data.reduce((acc, cur) => acc + (cur.PlayZoneStandard || 0), 0);
    const playZoneSurveillé = data.reduce((acc, cur) => acc + (cur.PlayZoneSurveillé || 0), 0);
    const playZoneKids = data.reduce((acc, cur) => acc + (cur.PlayZoneKids || 0), 0);
    const accesParent = data.reduce((acc, cur) => acc + (cur.AccesParent || 0), 0);

    // 🏎️ Car Race
    const carRaceJaune = data.reduce((acc, cur) => acc + (cur.CarRaceJaune || 0), 0);
    const carRaceNoir = data.reduce((acc, cur) => acc + (cur.CarRaceNoir || 0), 0);
    const carRaceRougeS = data.reduce((acc, cur) => acc + (cur.CarRaceRougeS || 0), 0);
    const carRaceRougeB = data.reduce((acc, cur) => acc + (cur.CarRaceRougeB || 0), 0);

    const packQR = data.reduce((acc, cur) => acc + (cur.PackQR || 0), 0);
    const rechargeQR = data.reduce((acc, cur) => acc + (cur.RechargeQR || 0), 0);
    const packCard = data.reduce((acc, cur) => acc + (cur.PackCard || 0), 0);
    const rechargeCard = data.reduce((acc, cur) => acc + (cur.RechargeCard || 0), 0);
    const twinClub = data.reduce((acc, cur) => acc + (cur.TwinClub || 0), 0);
    const twinToys = data.reduce((acc, cur) => acc + (cur.TwinToys || 0), 0);
    const challengeGames = data.reduce((acc, cur) => acc + (cur.ChallengeGames || 0), 0);
    const candyBar = data.reduce((acc, cur) => acc + (cur.CandyBar || 0), 0);
    const packAnnif = data.reduce((acc, cur) => acc + (cur.PackAnnif || 0), 0);

    const taxi = data.reduce((acc, cur) => acc + (cur.TaxiExpenses || 0), 0);
    const repair = data.reduce((acc, cur) => acc + (cur.RepairExpenses || 0), 0);
    const advance = data.reduce((acc, cur) => acc + (cur.StaffAdvance || 0), 0);
    const misc = data.reduce((acc, cur) => acc + (cur.MiscPurchases || 0), 0);
    const other = data.reduce((acc, cur) => acc + (cur.OtherExpenses || 0), 0);

    return {
      totalAmount,
      totalTpe,
      totalDailyExpenses,
      resultatnet,
      playZoneStandard,
      playZoneSurveillé,
      playZoneKids,
      accesParent,
      carRaceJaune,
      carRaceNoir,
      carRaceRougeS,
      carRaceRougeB,
      packQR,
      rechargeQR,
      packCard,
      rechargeCard,
      twinClub,
      twinToys,
      challengeGames,
      candyBar,
      packAnnif,
      taxi,
      repair,
      advance,
      misc,
      other
    };
  };

  const [somme, setSomme] = useState({
    totalAmount: 0,
    totalTpe: 0,
    totalDailyExpenses: 0,
    resultatnet: 0,
    playZoneStandard: 0,
    playZoneSurveillé: 0,
    playZoneKids: 0,
    accesParent: 0,
    carRaceJaune: 0,
    carRaceNoir: 0,
    carRaceRougeS: 0,
    carRaceRougeB: 0,
    packQR: 0,
    rechargeQR: 0,
    packCard: 0,
    rechargeCard: 0,
    twinClub: 0,
    twinToys: 0,
    challengeGames: 0,
    candyBar: 0,
    packAnnif: 0,
    taxi: 0,
    repair: 0,
    advance: 0,
    misc: 0,
    other: 0,
  });

  const [localisation, setLocalisation] = useState("All");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [recherche,setRecherche] = useState(false)

  const filterData = () => {
    setRecherche(true)
    if (!Array.isArray(rapports) || rapports.length === 0) {
      setFilteredData([]);
      return;
    }

    const start = startDate ? new Date(startDate) : null;
    const end = endDate ? new Date(endDate) : null;

    const filtered = rapports.filter((entry) => {
      const entryDate = new Date(entry.DateCollect);
      const isLocationMatch = localisation === "All" || entry.localisation === localisation;
      const isDateInRange = (!start || entryDate >= start) && (!end || entryDate <= end);
      return isLocationMatch && isDateInRange;
    });
console.log(filtered)
    setFilteredData(filtered);
    setSomme(calcul(filtered));
  };

  const groupDataByDate = (data) => {
  const grouped = {};

  data.forEach(entry => {
    const date = new Date(entry.DateCollect).toLocaleDateString("fr-FR");
    if (!grouped[date]) {
      grouped[date] = [];
    }
    grouped[date].push(entry);
  });

  return grouped;
};

const groupDataByLocation = (data) => {
  const grouped = {};
  data.forEach(entry => {
    const loc = entry.localisation;
    if (!grouped[loc]) {
      grouped[loc] = [];
    }
    grouped[loc].push(entry);
  });
  return grouped;
};



  const pieData = [
    { id: 0, value: somme.playZoneStandard, label: 'PlayZone Std' },
    { id: 1, value: somme.playZoneSurveillé, label: 'PlayZone Surv' },
    { id: 2, value: somme.playZoneKids, label: 'PlayZone Kids', color: '#8b5cf6' },
    { id: 3, value: somme.accesParent, label: 'Accès Parent' },
    { id: 4, value: somme.carRaceJaune, label: 'Car Race Jaune 🟡', color: '#eab308' },
    { id: 5, value: somme.carRaceNoir, label: 'Car Race Noir ⚫', color: '#334155' },
    { id: 6, value: somme.carRaceRougeS, label: 'Car Race Rouge S 🔴', color: '#ef4444' },
    { id: 7, value: somme.carRaceRougeB, label: 'Car Race Rouge B 🔴', color: '#b91c1c' },
    { id: 8, value: somme.packQR, label: 'Pack QR' },
    { id: 9, value: somme.rechargeQR, label: 'Recharge QR' },
    { id: 10, value: somme.packCard, label: 'Pack Card' },
    { id: 11, value: somme.rechargeCard, label: 'Recharge Card' },
    { id: 12, value: somme.twinClub, label: 'Twin Club' },
    { id: 13, value: somme.twinToys, label: 'Twin Toys' },
    { id: 14, value: somme.challengeGames, label: 'Challenge Games' },
    { id: 15, value: somme.candyBar, label: 'Candy Bar' },
    { id: 16, value: somme.packAnnif, label: 'Pack Annif' },
  ].filter(item => item.value > 0);

  const pieExpensesData = [
    { id: 0, value: somme.taxi, label: 'Taxi' },
    { id: 1, value: somme.repair, label: 'Réparation' },
    { id: 2, value: somme.advance, label: 'Avance' },
    { id: 3, value: somme.misc, label: 'Achats Divers' },
    { id: 4, value: somme.other, label: 'Autres' },
  ].filter(item => item.value > 0);

  const pieGlobalData = [
    { id: 0, value: somme.resultatnet, label: 'Net', color: '#4caf50' },
    { id: 1, value: somme.totalDailyExpenses, label: 'Dépenses', color: '#f44336' },
  ].filter(item => item.value > 0);

 const downloadPDF = async () => {
  const doc = new jsPDF();
  const categories = [
    "PlayZoneStandard", "PlayZoneSurveillé", "PlayZoneKids", "AccesParent",
    "CarRaceJaune", "CarRaceNoir", "CarRaceRougeS", "CarRaceRougeB",
    "PackQR", "RechargeQR", "PackCard", "RechargeCard",
    "TwinClub", "TwinToys", "ChallengeGames", "CandyBar", "PackAnnif"
  ];

  if (localisation === "All") {
    const dataByLocation = groupDataByLocation(filteredData);

    let firstPage = true;
    let imgData = null;

    if (chartRef.current) {
      try {
        const canvas = await html2canvas(chartRef.current, { scale: 2 });
        imgData = canvas.toDataURL('image/png');
      } catch (err) {
        console.error("Error generating chart for PDF", err);
      }
    }

    Object.entries(dataByLocation).forEach(([locName, locData]) => {
      const grouped = groupDataByDate(locData);
      const dates = Object.keys(grouped);
      const headers = ["Catégorie", ...dates, "Total"];

      const rows = categories.map(cat => {
        const row = [cat];
        let total = 0;
        dates.forEach(date => {
          const sum = grouped[date].reduce((acc, cur) => acc + (cur[cat] || 0), 0);
          row.push(sum);
          total += sum;
        });
        row.push(total);
        return row;
      });

      // Synthèse
      const totalAmountRow = ["Montant Total"];
      const totalTpeRow = ["Dont TPE"];
      const totalExpensesRow = ["Dépenses Totales"];
      const taxiRow = ["- Taxi"];
      const repairRow = ["- Réparation"];
      const advanceRow = ["- Avance"];
      const miscRow = ["- Achats Div"];
      const otherRow = ["- Autres"];
      const resultatNetRow = ["Résultat Net"];

      let totalAmountSum = 0;
      let totalTpeSum = 0;
      let totalExpensesSum = 0;
      let taxiSum = 0, repairSum = 0, advanceSum = 0, miscSum = 0, otherSum = 0;

      dates.forEach(date => {
        const entries = grouped[date];
        const amount = entries.reduce((acc, cur) => acc + (cur.TotalAmount || 0), 0);
        const tpe = entries.reduce((acc, cur) => acc + (cur.TotalTpe || 0), 0);
        const expenses = entries.reduce((acc, cur) => acc + (cur.DailyExpenses || 0), 0);
        
        totalAmountRow.push(amount);
        totalTpeRow.push(tpe);
        totalExpensesRow.push(expenses);
        resultatNetRow.push(amount - expenses);

        totalAmountSum += amount;
        totalTpeSum += tpe;
        totalExpensesSum += expenses;

        const taxi = entries.reduce((acc, cur) => acc + (cur.TaxiExpenses || 0), 0);
        const repair = entries.reduce((acc, cur) => acc + (cur.RepairExpenses || 0), 0);
        const advance = entries.reduce((acc, cur) => acc + (cur.StaffAdvance || 0), 0);
        const misc = entries.reduce((acc, cur) => acc + (cur.MiscPurchases || 0), 0);
        const other = entries.reduce((acc, cur) => acc + (cur.OtherExpenses || 0), 0);

        taxiRow.push(taxi); repairRow.push(repair); advanceRow.push(advance); miscRow.push(misc); otherRow.push(other);
        taxiSum += taxi; repairSum += repair; advanceSum += advance; miscSum += misc; otherSum += other;
      });

      totalAmountRow.push(totalAmountSum);
      totalTpeRow.push(totalTpeSum);
      totalExpensesRow.push(totalExpensesSum);
      taxiRow.push(taxiSum); repairRow.push(repairSum); advanceRow.push(advanceSum); miscRow.push(miscSum); otherRow.push(otherSum);
      resultatNetRow.push(totalAmountSum - totalExpensesSum);

      if (!firstPage) {
        doc.addPage();
      }
      
      let startY = 22;
      
      if (firstPage && imgData) {
        doc.addImage(imgData, 'PNG', 15, 25, 180, 90);
        startY = 120;
      }

      firstPage = false;

      doc.setFontSize(12);
      doc.text(`Rapport de recettes - ${locName}`, 14, startY - 12);
      doc.setFontSize(9);
      doc.text(`Plage de dates : ${startDate} à ${endDate}`, 14, startY - 5);

      const pdfBody = [
        [{ content: 'SECTION : RÉCAPITULATIF DES RECETTES', colSpan: headers.length, styles: { fillColor: [241, 245, 249], fontStyle: 'bold', halign: 'center' } }],
        ...rows,
        totalAmountRow,
        totalTpeRow,
        [{ content: 'SECTION : DÉTAIL DES DÉPENSES', colSpan: headers.length, styles: { fillColor: [241, 245, 249], fontStyle: 'bold', halign: 'center' } }],
        taxiRow,
        repairRow,
        advanceRow,
        miscRow,
        otherRow,
        totalExpensesRow,
        [{ content: 'BILAN FINAL', colSpan: headers.length, styles: { fillColor: [236, 253, 245], fontStyle: 'bold', halign: 'center' } }],
        resultatNetRow
      ];

      doc.autoTable({
        startY: startY,
        head: [headers],
        body: pdfBody,
        styles: { fontSize: 8, cellPadding: 3, overflow: 'linebreak' },
        headStyles: { fillGray: true, textColor: [255, 255, 255], fillColor: [26, 32, 44], fontStyle: 'bold' },
        alternateRowStyles: { fillColor: [252, 253, 254] },
        didParseCell: function(data) {
           const rowText = data.row.cells[0]?.raw;
           if (rowText === "TOTAL DES RECETTES" || rowText === "Dont TPE" || rowText === "TOTAL DES DÉPENSES" || rowText === "Résultat Net") {
              data.cell.styles.fontStyle = 'bold';
              if (rowText === "Résultat Net") {
                data.cell.styles.fillColor = [209, 250, 229];
                data.cell.styles.textColor = [5, 150, 105];
              }
           }
        }
      });
    });

  } else {
    // Cas d'une seule localisation
    const grouped = groupDataByDate(filteredData);
    const dates = Object.keys(grouped);
    const headers = ["Catégorie", ...dates, "Total"];

    const categories = [
      "PlayZoneStandard", "PlayZoneSurveillé", "PlayZoneKids", "AccesParent",
      "CarRaceJaune", "CarRaceNoir", "CarRaceRougeS", "CarRaceRougeB",
      "PackQR", "RechargeQR", "PackCard", "RechargeCard",
      "TwinClub", "TwinToys", "ChallengeGames", "CandyBar", "PackAnnif"
    ];

    const rows = categories.map(cat => {
      const row = [cat];
      let total = 0;
      dates.forEach(date => {
        const sum = grouped[date].reduce((acc, cur) => acc + (cur[cat] || 0), 0);
        row.push(sum);
        total += sum;
      });
      row.push(total);
      return row;
    });

    const totalAmountRow = ["Montant Total"];
    const totalTpeRow = ["Dont TPE"];
    const totalExpensesRow = ["Dépenses Totales"];
    const taxiRow = ["- Taxi"];
    const repairRow = ["- Réparation"];
    const advanceRow = ["- Avance"];
    const miscRow = ["- Achats Div"];
    const otherRow = ["- Autres"];
    const resultatNetRow = ["Résultat Net"];

    let totalAmountSum = 0;
    let totalTpeSum = 0;
    let totalExpensesSum = 0;
    let taxiSum = 0, repairSum = 0, advanceSum = 0, miscSum = 0, otherSum = 0;

    dates.forEach(date => {
      const entries = grouped[date];
      const amount = entries.reduce((acc, cur) => acc + (cur.TotalAmount || 0), 0);
      const tpe = entries.reduce((acc, cur) => acc + (cur.TotalTpe || 0), 0);
      const expenses = entries.reduce((acc, cur) => acc + (cur.DailyExpenses || 0), 0);
      
      totalAmountRow.push(amount);
      totalTpeRow.push(tpe);
      totalExpensesRow.push(expenses);
      resultatNetRow.push(amount - expenses);

      totalAmountSum += amount;
      totalTpeSum += tpe;
      totalExpensesSum += expenses;

      const taxi = entries.reduce((acc, cur) => acc + (cur.TaxiExpenses || 0), 0);
      const repair = entries.reduce((acc, cur) => acc + (cur.RepairExpenses || 0), 0);
      const advance = entries.reduce((acc, cur) => acc + (cur.StaffAdvance || 0), 0);
      const misc = entries.reduce((acc, cur) => acc + (cur.MiscPurchases || 0), 0);
      const other = entries.reduce((acc, cur) => acc + (cur.OtherExpenses || 0), 0);

      taxiRow.push(taxi); repairRow.push(repair); advanceRow.push(advance); miscRow.push(misc); otherRow.push(other);
      taxiSum += taxi; repairSum += repair; advanceSum += advance; miscSum += misc; otherSum += other;
    });

    totalAmountRow.push(totalAmountSum);
    totalTpeRow.push(totalTpeSum);
    totalExpensesRow.push(totalExpensesSum);
    taxiRow.push(taxiSum); repairRow.push(repairSum); advanceRow.push(advanceSum); miscRow.push(miscSum); otherRow.push(otherSum);
    resultatNetRow.push(totalAmountSum - totalExpensesSum);

    let startY = 22;

    if (chartRef.current) {
      try {
        const canvas = await html2canvas(chartRef.current, { scale: 2 });
        const imgData = canvas.toDataURL('image/png');
        doc.addImage(imgData, 'PNG', 15, 25, 180, 90);
        startY = 120;
      } catch (err) {
        console.error("Error generating chart for PDF", err);
      }
    }

    doc.setFontSize(12);
    doc.text(`Rapport de recettes - ${localisation}`, 14, startY - 12);
    doc.setFontSize(9);
    doc.text(`Plage de dates : ${startDate} à ${endDate}`, 14, startY - 5);

    const pdfBody = [
      [{ content: 'SECTION : RÉCAPITULATIF DES RECETTES', colSpan: headers.length, styles: { fillColor: [241, 245, 249], fontStyle: 'bold', halign: 'center' } }],
      ...rows,
      totalAmountRow,
      totalTpeRow,
      [{ content: 'SECTION : DÉTAIL DES DÉPENSES', colSpan: headers.length, styles: { fillColor: [241, 245, 249], fontStyle: 'bold', halign: 'center' } }],
      taxiRow,
      repairRow,
      advanceRow,
      miscRow,
      otherRow,
      totalExpensesRow,
      [{ content: 'BILAN FINAL', colSpan: headers.length, styles: { fillColor: [236, 253, 245], fontStyle: 'bold', halign: 'center' } }],
      resultatNetRow
    ];

    doc.autoTable({
      startY: startY,
      head: [headers],
      body: pdfBody,
      styles: { fontSize: 8, cellPadding: 3 },
      headStyles: { fillColor: [26, 32, 44], textColor: [255, 255, 255], fontStyle: 'bold' },
      alternateRowStyles: { fillColor: [252, 253, 254] },
      didParseCell: function(data) {
        const rowText = data.row.cells[0]?.raw;
        if (rowText === "Montant Total" || rowText === "Dont TPE" || rowText === "Dépenses Totales" || rowText === "Résultat Net") {
           data.cell.styles.fontStyle = 'bold';
           if (rowText === "Résultat Net") {
             data.cell.styles.fillColor = [209, 250, 229];
             data.cell.styles.textColor = [5, 150, 105];
           }
        }
     }
    });
  }

  doc.save("rapport_recettes_par_jour.pdf");
};

 

 const downloadExcel = () => {
  const wb = XLSX.utils.book_new();

  // Si All, on boucle sur les localisations
  if (localisation === "All") {
    const dataByLocation = groupDataByLocation(filteredData);

    Object.entries(dataByLocation).forEach(([locName, locData]) => {
      const grouped = groupDataByDate(locData);
      const dates = Object.keys(grouped);
      const headers = ["Catégorie", ...dates, "Total"];

      const categories = [
        "PlayZoneStandard", "PlayZoneSurveillé", "PlayZoneKids", "AccesParent",
        "CarRaceJaune", "CarRaceNoir", "CarRaceRougeS", "CarRaceRougeB",
        "PackQR", "RechargeQR", "PackCard", "RechargeCard",
        "TwinClub", "TwinToys", "ChallengeGames", "CandyBar", "PackAnnif"
      ];

      const dataRows = categories.map(cat => {
        const row = [cat];
        let total = 0;
        dates.forEach(date => {
          const sum = grouped[date].reduce((acc, cur) => acc + (cur[cat] || 0), 0);
          row.push(sum);
          total += sum;
        });
        row.push(total);
        return row;
      });

      const totalAmountRow = ["Montant Total"];
      const totalTpeRow = ["Dont TPE"];
      const totalExpensesRow = ["Dépenses Totales"];
      const taxiRow = ["- Taxi"];
      const repairRow = ["- Réparation"];
      const advanceRow = ["- Avance"];
      const miscRow = ["- Achats Div"];
      const otherRow = ["- Autres"];
      const resultatNetRow = ["Résultat Net"];

      let totalAmountSum = 0;
      let totalTpeSum = 0;
      let totalExpensesSum = 0;
      let taxiSum = 0, repairSum = 0, advanceSum = 0, miscSum = 0, otherSum = 0;

      dates.forEach(date => {
        const entries = grouped[date];
        const amount = entries.reduce((acc, cur) => acc + (cur.TotalAmount || 0), 0);
        const tpe = entries.reduce((acc, cur) => acc + (cur.TotalTpe || 0), 0);
        const expenses = entries.reduce((acc, cur) => acc + (cur.DailyExpenses || 0), 0);
        
        totalAmountRow.push(amount);
        totalTpeRow.push(tpe);
        totalExpensesRow.push(expenses);
        resultatNetRow.push(amount - expenses);

        totalAmountSum += amount;
        totalTpeSum += tpe;
        totalExpensesSum += expenses;

        const taxi = entries.reduce((acc, cur) => acc + (cur.TaxiExpenses || 0), 0);
        const repair = entries.reduce((acc, cur) => acc + (cur.RepairExpenses || 0), 0);
        const advance = entries.reduce((acc, cur) => acc + (cur.StaffAdvance || 0), 0);
        const misc = entries.reduce((acc, cur) => acc + (cur.MiscPurchases || 0), 0);
        const other = entries.reduce((acc, cur) => acc + (cur.OtherExpenses || 0), 0);

        taxiRow.push(taxi); repairRow.push(repair); advanceRow.push(advance); miscRow.push(misc); otherRow.push(other);
        taxiSum += taxi; repairSum += repair; advanceSum += advance; miscSum += misc; otherSum += other;
      });

      totalAmountRow.push(totalAmountSum);
      totalTpeRow.push(totalTpeSum);
      totalExpensesRow.push(totalExpensesSum);
      taxiRow.push(taxiSum); repairRow.push(repairSum); advanceRow.push(advanceSum); miscRow.push(miscSum); otherRow.push(otherSum);
      resultatNetRow.push(totalAmountSum - totalExpensesSum);

      const ws = XLSX.utils.aoa_to_sheet([
        headers,
        ...dataRows,
        [],
        totalAmountRow,
        totalTpeRow,
        totalExpensesRow,
        taxiRow,
        repairRow,
        advanceRow,
        miscRow,
        otherRow,
        resultatNetRow
      ]);

      XLSX.utils.book_append_sheet(wb, ws, locName.substring(0, 31)); // Nom de feuille max 31 chars
    });

  } else {
    // Cas simple : 1 seule localisation
    const grouped = groupDataByDate(filteredData);
    const dates = Object.keys(grouped);
    const headers = ["Catégorie", ...dates, "Total"];

    const categories = [
      "PlayZoneStandard", "PlayZoneSurveillé", "PlayZoneKids", "AccesParent",
      "CarRaceJaune", "CarRaceNoir", "CarRaceRougeS", "CarRaceRougeB",
      "PackQR", "RechargeQR", "PackCard", "RechargeCard",
      "TwinClub", "TwinToys", "ChallengeGames", "CandyBar", "PackAnnif"
    ];

    const dataRows = categories.map(cat => {
      const row = [cat];
      let total = 0;
      dates.forEach(date => {
        const sum = grouped[date].reduce((acc, cur) => acc + (cur[cat] || 0), 0);
        row.push(sum);
        total += sum;
      });
      row.push(total);
      return row;
    });

    const totalAmountRow = ["Montant Total"];
    const totalTpeRow = ["Dont TPE"];
    const totalExpensesRow = ["Dépenses Totales"];
    const taxiRow = ["- Taxi"];
    const repairRow = ["- Réparation"];
    const advanceRow = ["- Avance"];
    const miscRow = ["- Achats Div"];
    const otherRow = ["- Autres"];
    const resultatNetRow = ["Résultat Net"];

    let totalAmountSum = 0;
    let totalTpeSum = 0;
    let totalExpensesSum = 0;
    let taxiSum = 0, repairSum = 0, advanceSum = 0, miscSum = 0, otherSum = 0;

    dates.forEach(date => {
      const entries = grouped[date];
      const amount = entries.reduce((acc, cur) => acc + (cur.TotalAmount || 0), 0);
      const tpe = entries.reduce((acc, cur) => acc + (cur.TotalTpe || 0), 0);
      const expenses = entries.reduce((acc, cur) => acc + (cur.DailyExpenses || 0), 0);
      
      totalAmountRow.push(amount);
      totalTpeRow.push(tpe);
      totalExpensesRow.push(expenses);
      resultatNetRow.push(amount - expenses);

      totalAmountSum += amount;
      totalTpeSum += tpe;
      totalExpensesSum += expenses;

      const taxi = entries.reduce((acc, cur) => acc + (cur.TaxiExpenses || 0), 0);
      const repair = entries.reduce((acc, cur) => acc + (cur.RepairExpenses || 0), 0);
      const advance = entries.reduce((acc, cur) => acc + (cur.StaffAdvance || 0), 0);
      const misc = entries.reduce((acc, cur) => acc + (cur.MiscPurchases || 0), 0);
      const other = entries.reduce((acc, cur) => acc + (cur.OtherExpenses || 0), 0);

      taxiRow.push(taxi); repairRow.push(repair); advanceRow.push(advance); miscRow.push(misc); otherRow.push(other);
      taxiSum += taxi; repairSum += repair; advanceSum += advance; miscSum += misc; otherSum += other;
    });

    totalAmountRow.push(totalAmountSum);
    totalTpeRow.push(totalTpeSum);
    totalExpensesRow.push(totalExpensesSum);
    taxiRow.push(taxiSum); repairRow.push(repairSum); advanceRow.push(advanceSum); miscRow.push(miscSum); otherRow.push(otherSum);
    resultatNetRow.push(totalAmountSum - totalExpensesSum);

    const ws = XLSX.utils.aoa_to_sheet([
      headers,
      ...dataRows,
      [],
      totalAmountRow,
      totalTpeRow,
      totalExpensesRow,
      taxiRow,
      repairRow,
      advanceRow,
      miscRow,
      otherRow,
      resultatNetRow
    ]);

    XLSX.utils.book_append_sheet(wb, ws, localisation);
  }

  XLSX.writeFile(wb, "rapport_recettes_par_jour.xlsx");
};

  return (
    <div className="liste-rapports-twin">
      <h2>Recherche de Rapport Twin Park</h2>
      <div className="filter-form">
        <label>
          Localisation:
          <select value={localisation} onChange={(e) => setLocalisation(e.target.value)}>
            <option value="All">Tous les emplacements</option>
            {locations.length > 0 ? (
              locations.map(loc => (
                <option key={loc._id} value={loc.name}>{loc.name}</option>
              ))
            ) : (
              <>
                <option>Twin Park- Manar City</option>
                <option>Twin Park - Tunisia Mall</option>
                <option>Twin park - Jardins d'eL Menzah</option>
                <option>Jump Zone Mall of Djerba</option>
              </>
            )}
          </select>
        </label>

        <label>
          Start Date:
          <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
        </label>

        <label>
          End Date:
          <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
        </label>

        <button onClick={filterData}>Confirm</button>
      </div>
    {
      recherche &&
      <div className="filtered-data">
        <h3>Résultats trouvés</h3>
        <div className="premium-table-container">
          <table className="premium-table">
            <thead>
              <tr>
                <th>RUBRIQUES DE RECETTES PAR CATÉGORIE</th>
                <th>MONTANT (TND)</th>
                <th>RUBRIQUES DE DÉPENSES</th>
                <th>MONTANT (TND)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>🏰 PlayZone Standard / Surveillé</td>
                <td>{(somme.playZoneStandard + somme.playZoneSurveillé).toFixed(3)}</td>
                <td>Frais de Taxi</td>
                <td>{somme.taxi.toFixed(3)}</td>
              </tr>
              <tr style={{ backgroundColor: '#faf5ff' }}>
                <td style={{ color: '#8b5cf6', fontWeight: 'bold' }}>🏰 PlayZone Kids 🎈</td>
                <td style={{ color: '#8b5cf6', fontWeight: 'bold' }}>{somme.playZoneKids.toFixed(3)}</td>
                <td>-</td>
                <td>-</td>
              </tr>
              <tr style={{ backgroundColor: '#fefce8' }}>
                <td style={{ color: '#d97706', fontWeight: 'bold' }}>🏎️ Car Race Total (Jaune, Noir, Rouge S, Rouge B)</td>
                <td style={{ color: '#d97706', fontWeight: 'bold' }}>
                  {(somme.carRaceJaune + somme.carRaceNoir + somme.carRaceRougeS + somme.carRaceRougeB).toFixed(3)}
                </td>
                <td>-</td>
                <td>-</td>
              </tr>
              <tr style={{ fontSize: '0.85rem', color: '#64748b' }}>
                <td style={{ paddingLeft: '20px' }}>└ 🟡 Jaune: {somme.carRaceJaune.toFixed(3)} | ⚫ Noir: {somme.carRaceNoir.toFixed(3)} | 🔴 Rouge S: {somme.carRaceRougeS.toFixed(3)} | 🔴 Rouge B: {somme.carRaceRougeB.toFixed(3)}</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
              </tr>
              <tr>
                <td>Accès Parent / Pack Annif</td>
                <td>{(somme.accesParent + somme.packAnnif).toFixed(3)}</td>
                <td>Frais de Réparation</td>
                <td>{somme.repair.toFixed(3)}</td>
              </tr>
              <tr>
                <td>Packs & Recharges (QR / Card)</td>
                <td>{(somme.packQR + somme.rechargeQR + somme.packCard + somme.rechargeCard).toFixed(3)}</td>
                <td>Avance Personnel</td>
                <td>{somme.advance.toFixed(3)}</td>
              </tr>
              <tr>
                <td>Ventes (Toys, Games, Candy)</td>
                <td>{(somme.twinToys + somme.challengeGames + somme.candyBar).toFixed(3)}</td>
                <td>Achats Divers</td>
                <td>{somme.misc.toFixed(3)}</td>
              </tr>
              <tr>
                <td>Twin Club</td>
                <td>{somme.twinClub.toFixed(3)}</td>
                <td>Autres Dépenses</td>
                <td>{somme.other.toFixed(3)}</td>
              </tr>
              <tr className="summary-row">
                <td style={{ color: '#0ea5e9' }}>Dont Paiements par TPE (Total)</td>
                <td style={{ color: '#0ea5e9' }}>{somme.totalTpe.toFixed(3)}</td>
                <td>-</td>
                <td>-</td>
              </tr>
              <tr className="summary-total">
                <td>TOTAL DES RECETTES</td>
                <td>{somme.totalAmount.toFixed(3)}</td>
                <td>TOTAL DES DÉPENSES</td>
                <td>{somme.totalDailyExpenses.toFixed(3)}</td>
              </tr>
              <tr className="summary-net">
                <td colSpan="2">RÉSULTAT NET DE LA PÉRIODE</td>
                <td colSpan="2" className="net-value">{somme.resultatnet.toFixed(3)} TND</td>
              </tr>
            </tbody>
          </table>
        </div>

        {pieData.length > 0 && (
          <div ref={chartRef} style={{ background: '#ffffff', padding: '30px', borderRadius: '15px', marginBottom: '30px', border: '1px solid #e2e8f0', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)', width: '100%' }}>
            <h4 style={{textAlign: 'center', marginBottom: '40px', color: '#1a202c', fontWeight: 800, letterSpacing: '-0.025em'}}>Analyses Graphiques Décisives</h4>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start', gap: '15px', flexWrap: 'nowrap', overflowX: 'auto' }}>
              
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1, minWidth: '350px' }}>
                <h5 style={{ fontSize: '14px', marginBottom: '10px', color: '#4a5568', fontWeight: 600 }}>Recettes</h5>
                <PieChart
                  series={[{ 
                    data: pieData, 
                    innerRadius: 35, 
                    outerRadius: 80, 
                    paddingAngle: 2, 
                    cornerRadius: 6,
                  }]}
                  width={350}
                  height={220}
                  slotProps={{ legend: { position: { vertical: 'middle', horizontal: 'right' }, itemMarkWidth: 8, itemMarkHeight: 8, labelStyle: { fontSize: 9 } } }}
                />
              </div>

              {pieExpensesData.length > 0 && (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1, minWidth: '350px', borderLeft: '1px solid #f1f5f9', borderRight: '1px solid #f1f5f9' }}>
                  <h5 style={{ fontSize: '14px', marginBottom: '10px', color: '#4a5568', fontWeight: 600 }}>Dépenses</h5>
                  <PieChart
                    series={[{ 
                      data: pieExpensesData, 
                      innerRadius: 35, 
                      outerRadius: 80, 
                      paddingAngle: 2, 
                      cornerRadius: 6,
                    }]}
                    width={350}
                    height={220}
                    slotProps={{ legend: { position: { vertical: 'middle', horizontal: 'right' }, itemMarkWidth: 8, itemMarkHeight: 8, labelStyle: { fontSize: 9 } } }}
                  />
                </div>
              )}

              {pieGlobalData.length > 0 && (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1, minWidth: '350px' }}>
                  <h5 style={{ fontSize: '14px', marginBottom: '10px', color: '#4a5568', fontWeight: 600 }}>Global (Net vs Exp)</h5>
                  <PieChart
                    series={[{ 
                      data: pieGlobalData, 
                      innerRadius: 35, 
                      outerRadius: 80, 
                      paddingAngle: 2, 
                      cornerRadius: 6,
                    }]}
                    width={350}
                    height={220}
                    slotProps={{ legend: { position: { vertical: 'middle', horizontal: 'right' }, itemMarkWidth: 8, itemMarkHeight: 8, labelStyle: { fontSize: 9 } } }}
                  />
                </div>
              )}

            </div>
          </div>
        )}

        <div className="actions-container">
          <Button variant="primary" onClick={downloadPDF}>
            Télécharger en PDF
          </Button>
          <Button variant="success" onClick={downloadExcel}>
            Télécharger en Excel
          </Button>
        </div>

        {filteredData.length > 0 ? (
          <div className="rapports-grid">
            {filteredData.map((el, i) => (
              <CardRapportTwin key={i} el={el} />
            ))}
          </div>
        ) : (
          <p>Aucun résultat trouvé</p>
        )}
      </div>
    }
    </div>

    // <div>
      
    //   <div>
    //     {
    //       rapports.map((el,i,t)=> <CardRapportTwin el={el}/>)
    //     }
    //   </div>
    // </div>
  );
}

export default ListeRapportsTwin;
